/**
 * The machine page's "Ask about this machine" starters — demo line 2205.
 *
 * Moved out of `modules/fleet/MachineHistoryTab.tsx` (fork, oem v1.8) so the
 * assistant's regression gate (`scripts/oem/check-assistant.mjs`, via
 * `shared/assistant/intent-cases.ts`) can harvest them alongside every other
 * chip. The tab still renders them; this is only where the strings live.
 *
 * The tab sends each one as `${q.replace('this machine', id)} (${id})` — see
 * {@link machineAskPrompt}, which both the tab and the harvest use so the two
 * cannot disagree about what the assistant receives.
 *
 * Data Schema layer — pure data.
 */

/** Demo line 2205. The four starter questions under the Ask box. */
export const MACHINE_ASK_STARTERS = [
  'What is the breakdown trend on this machine?',
  'What has it cost per operating hour and why?',
  'Which component should we change next?',
  'What is its energy and emissions profile?',
] as const;

/** The exact text the machine page sends for a starter (or a typed question). */
export const machineAskPrompt = (question: string, machineId: string): string =>
  `${question.replace('this machine', machineId)} (${machineId})`;
